    <button
      mat-flat-button
      class="bg-slate-500 text-white dark:bg-slate-300 dark:text-black"
      (click)="openDialog()"
    >
      Change Password
    </button>
